module.exports = " <div class=row> <div class=col-xs-12> <div ng-include=\"'visibility-header'\"></div> </div> <div class=\"col-md-12 blanco\"> <div ng-include=\"'visibility-list'\"></div> <div ng-include=\"'visibility-details'\"></div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/extensionVisibility/visibility/list/visibilityList.html
// module id = 632
// module chunks = 0